// BuyChallengeHeader.tsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import classes from './_buyChallenge.module.scss';

const BuyChallengeHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <nav className={classes.nav}>
      <div className={classes.mobileNav}>
        <Link to="http://raisemyfunds.co/">
          <img src={require('../../assets/images/squareLogo.png')} alt="" />
        </Link>
        <div className={classes.mobileButtons}>
          <Button variant="outlined" onClick={() => navigate('/login')}>
            Login
          </Button>
        </div>
      </div>
      <div className={classes.wrapper}>
        <Link to="http://raisemyfunds.co/">
          <img src={require('../../assets/images/fullLogo.png')} alt="" />
        </Link>
        <ul>
          <li>
            <Link to={'http://raisemyfunds.co/the-challenge/'}>
              The Challenge
            </Link>
          </li>
          <li>
            <Link to={'http://raisemyfunds.co/faq/'}>FAQ</Link>
          </li>
          <li>
            <Link to={'http://raisemyfunds.co/about-us/'}>About Us</Link>
          </li>
          <li>
            <Link to={'http://raisemyfunds.co/partner/'}>
              Be a Partner
            </Link>
          </li>
          <li>
            <Link to={'http://raisemyfunds.co/contact-us/'}>
              Contact Us
            </Link>
          </li>
        </ul>
        <div>
          <Button variant="contained" onClick={() => navigate('/login')}>
            Login
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default BuyChallengeHeader;
